import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import HomeTire from '@/pages/hometire'
import Color from '@/pages/color'
import VandM from '@/components/vandm'
import WidgUser from '@/components/widguser'
import MainTires from '@/components/maintires'
import WidgFinish from '@/components/widgfinish'
import Main from '@/components/main'
import Rewidg from '@/components/rewidg'
import NewCalc from '@/components/new_calc'
import DetailsForm from '@/components/details_form'
import PageNotFound from '../pages/page_not_found'

Vue.use(Router)
Vue.component('WidgUser', WidgUser)
Vue.component('WidgFinish', WidgFinish)
Vue.component('VandM', VandM)
Vue.component('NewCalc', NewCalc)
Vue.component('MainTires', MainTires)
Vue.component('Main', Main)
Vue.component('Rewidg', Rewidg)
Vue.component('DetailsForm', DetailsForm)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/color/',
      name: 'Color',
      component: Color,
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/hometire',
      name: 'HomeTire',
      component: HomeTire,
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js